import styled from '@emotion/styled';
import { IconButton } from 'react-magma-dom';
import { COLORS } from '../../constants';
import { DRAGGABLE_FONT } from './StyledDraggableLabel';
import { StyledScroll } from './StyledScroll';

export const StyledMainContent = styled.div<{
  isProforma: boolean;
  isFullScreen: boolean;
  isBottomSectionExpanded: boolean;
  isEditMode: boolean;
}>`
  height: ${({ isFullScreen }) => (isFullScreen ? '100%' : 'auto')};
  padding: 22px 0
    ${({ isProforma, isBottomSectionExpanded }) => (isProforma ? '144px' : isBottomSectionExpanded ? '60px' : '127px')};
  ${({ isBottomSectionExpanded, isEditMode }) => isBottomSectionExpanded && isEditMode && 'padding-bottom: 17px'};
  margin: 0 auto;
  ${({ isFullScreen }) => isFullScreen && 'width: 100%;'}
  max-width: 100%;
  ${({ isFullScreen }) => (isFullScreen ? 'overflow-y: auto; padding-top: 23px;' : '')}
  ${({ isFullScreen, isEditMode }) =>
    isFullScreen ? (isEditMode ? 'padding-bottom: 17px;' : 'padding-bottom: 58px;') : ''}
  font-variant-ligatures: no-common-ligatures;
  ${StyledScroll}
`;

export const StyledLabelContent = styled.input`
  ${DRAGGABLE_FONT}
  height: 35px;
  min-width: 50px;
  background: transparent;
  border: none;
  box-sizing: content-box;
  :focus {
    outline: none;
  }
`;

export const StyledRemoveBtn = styled(IconButton)`
  position: absolute !important;
  width: 20px !important;
  height: 20px !important;
  margin: -10px 0 0 -10px !important;
  background-color: ${COLORS.white}!important;
  color: ${COLORS.black}!important;
  :hover,
  :focus {
    background: ${COLORS.emperor} !important;
  }
`;
